
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[id]",
      function () {
        return require("private-next-pages/store/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[id]"])
      });
    }
  